import React, {Component} from 'react'
import PropTypes from 'prop-types'
import { Field, reduxForm } from 'redux-form'
import { NavLink } from 'react-router-dom'
import moment from 'moment'
import {Element, scroller} from 'react-scroll'
import VehicleSelectFormComponent from '../../../components/redux-form/VehicleSelectFormComponent'
import VirtualizedSelectFormComponent from '../../../components/redux-form/VirtualizedSelectFormComponent'
import FileInputField from '../../../components/FileInputField'

class MarkRequest extends Component {
  static propTypes = {
    markTypes: PropTypes.arrayOf(PropTypes.object),
    handleSubmit: PropTypes.func,
    addresses: PropTypes.array,
    documents: PropTypes.array,
    onDocumentSelect: PropTypes.func,
    onSubmit: PropTypes.func.isRequired,
    loading: PropTypes.bool,
    markExpirationDate: PropTypes.object,
    onMarkTypeSelected: PropTypes.func.isRequired,
    onVehicleSelected: PropTypes.func.isRequired,
    selectedMarkType: PropTypes.object,
    selectedVehicles: PropTypes.arrayOf(PropTypes.object),
    errors: PropTypes.string,
    user: PropTypes.object,
    vehicleOwnershipTypes: PropTypes.arrayOf(PropTypes.object),
    vehiclePowerSupplies: PropTypes.arrayOf(PropTypes.object),
    markRules: PropTypes.object,
    onVehicleAdd: PropTypes.func,
    onVehicleRemove: PropTypes.func,
    onVehiclePropertyTypeChange: PropTypes.func,
    onVehiclePowerSupplyChange: PropTypes.func,
    price: PropTypes.object,
    submitting: PropTypes.bool,
    selectedDocuments: PropTypes.arrayOf(PropTypes.object),
    onDocumentAdd: PropTypes.func,
    onDocumentRemove: PropTypes.func,
    onDocumentChange: PropTypes.func
  }

  render () {
    const {
      markTypes,
      loading,
      markExpirationDate,
      errors,
      documents,
      onDocumentSelect,
      onMarkTypeSelected,
      selectedMarkType,
      selectedVehicles,
      vehicleOwnershipTypes,
      onVehicleSelected,
      vehiclePowerSupplies,
      markRules,
      onVehicleAdd,
      onVehicleRemove,
      onVehiclePropertyTypeChange,
      onVehiclePowerSupplyChange,
      price,
      submitting,
      addresses,
      selectedDocuments,
      onDocumentAdd,
      onDocumentRemove,
      onDocumentChange
    } = this.props

    if (loading) {
      return (
        <div>Caricamento in corso...</div>
      )
    }

    let userArea
    if (this.props.user.residenceArea) {
      userArea = this.props.user.residenceArea.code
    } else {
      userArea = this.props.user.workArea.code
    }

    return (
      <form onSubmit={this.props.handleSubmit(values => {
        this.props.onSubmit({...values})
      })}>
        <div className="col-md-8 col-md-push-2">
          <div className="panel panel-default panel-border">
            <div className="panel-body">
              <NavLink to="/user-area" className="btn btn-green btn-lg-back">Torna indietro</NavLink>
              <h2 className="title title-special">Richiedi Contrassegno</h2>
              <p>Da qui puoi richiedere un nuovo contrassegno per la sosta nel Comune di Empoli<br /></p>

              <div className="box">
                <fieldset>
                  <div className="titolo-categoria">
                    <legend className="text-left">Tipologia Contrassegno</legend>
                    <p>Seleziona il tipo di contrassegno di cui neccessiti tra quelli disponibili per il tuo utente</p>
                  </div>

                  <div className="row">
                    {markTypes.map((item, i) => {
                      let activeClass = ''
                      const multipleAreas = item.Areas.length > 1

                      if (selectedMarkType && selectedMarkType.id === item.id) {
                        activeClass = ' active'
                      }

                      return (
                        <div key={i} className="col-sm-6 col-md-6 col-lg-6 col-xl-6">
                          <div
                            onClick={() => onMarkTypeSelected(item)}
                            className={'panel panel-default park-ticket-panel panel-border' + activeClass}>
                            <div className="panel-body text-center">
                              <h4>{item.name}</h4>

                              {!item.free ? (
                                <h3 className="title3">
                                  A pagamento
                                </h3>
                              ) : (
                                <h3>
                                  Gratuito
                                </h3>
                              )}
                              <div className="panel-body flex-grow panel-2">
                                Valido nell{multipleAreas ? 'e' : 'a'} zon{multipleAreas ? 'e' : 'a'}:{' '}
                                {item.Areas.map((areaItem, index) => (
                                  <span key={index}>
                                    <strong>{areaItem.code}</strong>
                                    {index === item.Areas.length - 1 ? '' : ', '}
                                  </span>
                                ))}
                                <br />
                                Valido fino al: <strong>{moment(markExpirationDate.value).format('L')}</strong>
                              </div>
                            </div>
                          </div>
                        </div>
                      )
                    })}
                    <Field name="markType" component="input" type="hidden" />
                  </div>
                </fieldset>
              </div>

              {(selectedMarkType && markRules.id) && <div className="box">
                <fieldset>
                  <div className="titolo-categoria">
                    <Element name="step-two" />
                    <legend className="text-left">Veicoli</legend>
                    <p>
                      Questo contrassegno è utilizzabile su un massimo di {markRules.vehicleLimit} veicol{markRules.vehicleLimit > 1 ? 'i' : 'o'}
                    </p>
                    <div className="row">
                      <div className="col-md-12 text-left">
                        <a style={{margin: '0 10px 0 17px'}} type="button" className="btn btn-info btn-xs" onClick={onVehicleAdd}>
                          Aggiungi Veicolo
                        </a>
                        <span className={selectedVehicles.length >= markRules.vehicleLimit ? 'text-danger' : 'text-primary'}>
                          {' Veicoli Utilizzati: ' + selectedVehicles.length} / {markRules.vehicleLimit}
                        </span>
                      </div>
                    </div>
                  </div>

                  {selectedVehicles.map((item, index) => {
                    return (
                      <div className="row" key={'vehicle-' + index} style={{padding: '20px'}}>
                        <div className="col-md-3 text-left">
                          <label>Targa B</label>
                          <Field
                            component={VehicleSelectFormComponent}
                            onValueChange={(value) => onVehicleSelected(value, index)}
                            vehicles={this.props.user.vehicles}
                            required
                            name={'vehicle' + index}
                            newveicle={true}
                            className="resident-login" />
                        </div>

                        {!item.id && (
                          <div className="col-md-4 text-left">
                            <label>Tipologia di alimentazione</label>
                            <Field
                              onChange={(e) => onVehiclePowerSupplyChange(e, index)}
                              required
                              name={'powerSupply' + index}
                              component="select"
                              className="form-control sel1-control">
                              <option value={''}>Seleziona tipo di alimentazione</option>
                              {item.plate_number ? vehiclePowerSupplies.map((item, index) => (
                                <option key={index} value={item.id}>{item.name}</option>
                              )) : <option value={''}>Seleziona una targa prima</option>}
                            </Field>
                          </div>
                        )}

                        {!item.id && (
                          <div className="col-md-4 text-left">
                            <label>Tipologia di proprietà</label>
                            <Field
                              onChange={(e) => onVehiclePropertyTypeChange(e, index)}
                              required
                              name={'ownershipType' + index}
                              component="select"
                              className="form-control sel1-control">
                              <option value={''}>Seleziona tipo di proprietà</option>
                              {item.plate_number ? vehicleOwnershipTypes.map((item, index) => (
                                <option key={index} value={item.id}>{item.name}</option>
                              )) : <option value={''}>Seleziona una targa prima</option>}
                            </Field>
                          </div>
                        )}

                        {item.id && (
                          <div className="col-md-4 text-left">
                            <label>Tipologia di alimentazione</label>
                            <div style={{marginTop: 12}}>
                              <h4>{item.VehiclePowerSupply.name}</h4>
                            </div>
                          </div>
                        )}

                        {item.id && (
                          <div className="col-md-4 text-left">
                            <label>Tipologia di propriet&agrave;</label>
                            <div style={{marginTop: 12}}>
                              <h4>{item.VehicleOwnershipType.name}</h4>
                            </div>
                          </div>
                        )}

                        <div className="col-md-1 text-left" style={{marginTop: '30px'}}>
                          <a onClick={() => onVehicleRemove(index)} className="btn btn-xs btn-danger">Rimuovi</a>
                        </div>
                      </div>
                    )
                  })}
                </fieldset>
              </div>}

              {(selectedMarkType && markRules.id && selectedVehicles.length > 0 && documents.length > 0) &&
              <div className="box">
                <fieldset>
                  <div className="titolo-categoria">
                    <Element name="step-three" />
                    <legend className="text-left">Documenti</legend>
                    <p>
                      La richiesta di questo contrassegno richiede l'upload dei seguenti documenti:{' '}
                      <strong>
                        {documents.map((item, index) => {
                          return `${item.typeName}${index === documents.length - 1 ? '' : (
                            index === documents.length - 2 ? ' e ' : ', '
                          )}`
                        })}.
                      </strong>
                    </p>
                    <p>I file caricati devono essere nel formato: png, jpeg, pdf.</p>
                  </div>

                  <div className="row">
                    <div className="col-md-12 text-left">
                      <a style={{margin: '0 10px 10px 17px'}} type="button" className="btn btn-info btn-xs" onClick={onDocumentAdd}>
                        Aggiungi Documento
                      </a>
                    </div>
                  </div>

                  {selectedDocuments.map((item, index) => {
                    return (
                      <div className="form-group row" key={'document-' + index}>
                        <label className="col-sm-5 text-right" style={{textOverflow: 'ellipsis'}}>
                          {item.DocumentType ? item.DocumentType.name : 'Seleziona un documento'}
                        </label>
                        <div className="col-sm-5">
                          <Field
                            onChange={(document) => { onDocumentChange(document, index) }}
                            name={'documentFile-' + index}
                            component={FileInputField}
                            required
                          />
                        </div>
                        <div className="col-sm-2">
                          <a onClick={() => onDocumentRemove(index)} className="btn btn-xs btn-danger">Rimuovi</a>
                        </div>
                      </div>
                    )
                  })}

                  {/* documents.map((item, index) => {
                    if (item.slug === 'carta_circolazione_veicoli') {
                      return selectedVehicles.map((vehicleItem, index) => {
                        if (vehicleItem.plate_number) {
                          return (
                            <div className="form-group row" key={'document_' + vehicleItem.plate_number.toLowerCase()}>
                              <label className="col-sm-5 text-right">
                                {`${item.typeName} per il veicolo: ${vehicleItem.plate_number.toUpperCase()}`}
                              </label>
                              <div className="col-sm-7">
                                <Field
                                  name={'documentFile-' + vehicleItem.plate_number.toLowerCase()}
                                  component={FileInputField}
                                  // documentTypeId={item.documentTypeId}
                                  required
                                />
                              </div>
                            </div>
                          )
                        }
                        return null
                      })
                    }

                    return (
                      <div className="form-group row" key={'document-' + index}>
                        <label className="col-sm-5 text-right">
                          {item.typeName}
                        </label>
                        <div className="col-sm-7">
                          <Field
                            name={'documentFile-' + item.documentTypeId}
                            component={FileInputField}
                            // documentTypeId={item.documentTypeId}
                            required
                          />
                        </div>
                      </div>
                    )
                  }) */}
                </fieldset>
              </div>
              }

              {(selectedMarkType && markRules.id && userArea.indexOf('ZTL') > -1) && (
                <div className="box">
                  <fieldset>
                    <div className="titolo-categoria">
                      <legend className="text-left">Indirizzo di Partenza</legend>
                      <p>
                        Questo contrassegno richiede l'indicazione dell'indirizzo di partenza
                      </p>
                    </div>
                    <div className="col-md-7 text-left">
                      <label>Indirizzo di Partenza</label>
                      <Field
                        name="startAddress"
                        options={addresses.map(item => {
                          return {
                            label: item.name,
                            value: item.id
                          }
                        })} component={VirtualizedSelectFormComponent} required />
                    </div>
                  </fieldset>
                </div>
              )}

              {price && <div className="box">
                <fieldset>
                  <div className="titolo-categoria">
                    <Element name="step-final" />
                    <legend className="text-left">Riepilogo</legend>
                  </div>

                  <div className="col-md-6">
                    <div className="card-marks">
                      <div className="caption" style={{padding: 10}}>
                        <h5>
                          <strong>{selectedMarkType.label}</strong>
                        </h5>
                        <div>
                          <h5>
                          Valido nell{selectedMarkType.Areas.length > 1 ? 'e' : 'a'} zon{selectedMarkType.Areas.length > 1 ? 'e' : 'a'}:{' '}
                          {selectedMarkType.Areas.map((areaItem, index) => (
                            <span key={index}>
                              <strong>{areaItem.code}</strong>
                              {index === selectedMarkType.Areas.length - 1 ? '' : ', '}
                            </span>
                          ))}
                          </h5>
                          <h5>Targ{selectedVehicles.length > 1 ? 'he' : 'a'}: <strong>{selectedVehicles.map(item => item.plate_number + ' ')}</strong></h5>
                          <h5>Valido fino al: <strong>{moment(markExpirationDate.value).format('L')}</strong></h5>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="col-md-6">
                    <h3>Totale: € {Number(price.price).toLocaleString('it-IT', {minimumFractionDigits: 2, maximumFractionDigits: 2})}</h3>
                    {price.reasons && price.reasons.length > 0 ? price.reasons.map((item, index) => {
                      return (
                        <h5 className="text-info" key={'reasons-' + index}>{item}</h5>
                      )
                    }) : null}
                  </div>
                </fieldset>

                {submitting && <div className="box text-info">Richiesta in corso...</div>}

                <button type="submit" className="btn btn-green btn-lg-back">
                  Richiedi Contrassegno
                </button>
              </div>}

              {errors && <div className="box text-danger">
                {errors}
              </div>}
            </div>
          </div>
        </div>
      </form>
    )
  }
}

export default reduxForm({
  form: 'markRequest',
  enableReinitialize: false
})(MarkRequest)



// WEBPACK FOOTER //
// ./src/containers/UserArea/MarkRequest/MarkRequest.js